import React from 'react';
import PropTypes from 'prop-types';
import { FlexGrid, Text } from '@gasbuddy/react-components';
import styles from './OutageStatusBadges.module.css';
import EmergencyStatusReport from '../../prop-types/emergency-status-report';
import ReportedBy from '../ReportedBy';

export default function OutageStatusBadges({ powerReport, gasReport, dieselReport, sellsDiesel, iconsOnly }) {
  const hasPower = powerReport.status;
  const hasGas = gasReport.status;
  const hasDiesel = dieselReport && dieselReport.status;

  const powerIconSrc = `//static.gasbuddy.com/web/icons/${hasPower ? '' : 'no-'}power-circle.svg`;
  const gasIconSrc = `//static.gasbuddy.com/web/icons/${hasGas ? '' : 'no-'}gas-circle.svg`;
  const dieselIconSrc = `//static.gasbuddy.com/web/icons/${hasDiesel ? '' : 'no-'}diesel-circle.svg`;

  const powerTitle = hasPower ? 'Has Power' : 'Has No Power';
  const gasTitle = hasGas ? 'Has Gas' : 'Has No Gas';
  const dieselTitle = hasDiesel ? 'Has Diesel' : 'Has No Diesel';

  return (
    <FlexGrid className={`${styles.statusList} ${!iconsOnly ? '' : styles.iconsOnly}`}>
      <FlexGrid.Column className={styles.status}>
        <img
          className={styles.statusIcon}
          src={powerIconSrc}
          alt={powerTitle}
          title={powerTitle}
        />
        {!iconsOnly && (
          <div>
            <Text className={styles.title} color="red">Power</Text>
            <ReportedBy username={powerReport.username} time={powerReport.timestamp} />
          </div>
        )}
      </FlexGrid.Column>
      <FlexGrid.Column className={styles.status}>
        <img
          className={styles.statusIcon}
          src={gasIconSrc}
          alt={gasTitle}
          title={gasTitle}
        />
        {!iconsOnly && (
          <div>
            <Text className={styles.title} color="red">Gas</Text>
            <ReportedBy username={gasReport.username} time={gasReport.timestamp} />
          </div>
        )}
      </FlexGrid.Column>
      {sellsDiesel && (
        <FlexGrid.Column className={styles.status}>
          <img
            className={styles.statusIcon}
            src={dieselIconSrc}
            alt={dieselTitle}
            title={dieselTitle}
          />
          {!iconsOnly && (
            <div>
              <Text className={styles.title} color="red">Diesel</Text>
              <ReportedBy username={dieselReport.username} time={dieselReport.timestamp} />
            </div>
          )}
        </FlexGrid.Column>
      )}
    </FlexGrid>
  );
}

OutageStatusBadges.propTypes = {
  powerReport: EmergencyStatusReport,
  gasReport: EmergencyStatusReport,
  dieselReport: EmergencyStatusReport,
  sellsDiesel: PropTypes.bool,
  iconsOnly: PropTypes.bool,
};

OutageStatusBadges.defaultProps = {
  powerReport: {
    status: true,
  },
  gasReport: {
    status: true,
  },
  dieselReport: undefined,
  sellsDiesel: false,
  iconsOnly: false,
};
